import React from 'react';
import {Link} from "react-router-dom";

import ListButton from './listButton.js'
import Pagination from './pagination.js'
import SectionHeader from './sectionHeader.js'

import {_countryNameFromCode} from '../helpers/helpers.js'
import CountryFlagAndName from './countryFlagAndName.js'

import {IPAddressesSection, LinkingIPAddress} from '../../../server/routes/website.js'

interface DomainLinkingIPsProps {
    ipAddresses?: IPAddressesSection;
}

export default function DomainLinkingIPs({ipAddresses}: DomainLinkingIPsProps) {
    if (!ipAddresses) return null;

    return (<>
        <div className = "row row-50">
            <div className = "col-12">
                <SectionHeader header={ipAddresses.Header} anchor='linking'/>
                <div className="table-outer table-rounded table-responsive-lg">
                    <table className="table-custom table-custom-striped table-custom-primary">
                        <thead>
                            <tr>
                                <th style={{width: '40%'}}>IP Addresses</th>
                                <th style={{width: '30%'}}>Country</th>
                                <th style={{width: '30%'}}>Linking domains count</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                ipAddresses.Addresses.map((ipAddress, indexKey) =>
                                    <IPAddressRow ipAddress={ipAddress} key={indexKey}/>
                                )
                            }
                        </tbody>
                    </table>
                </div>
                <Pagination pages={ipAddresses.Pages}/>
                <ListButton button={ipAddresses.Button} />
            </div>
        </div>
    </>)
}

interface IPAddressRowProps {
    ipAddress: LinkingIPAddress;
}

function IPAddressRow({ipAddress}: IPAddressRowProps) {
    return (
        <tr>
            <td>
                <Link 
                    to={`/ip/${ipAddress.IP}`} 
                    className="link-hover" 
                    title={`Reverse IP for ${ipAddress.IP}`} 
                >
                    {ipAddress.IP}
                </Link>
            </td>
            <td>
                <CountryFlagAndName countryCode={ipAddress.Country} />
            </td>
            <td>
                <b>
                    {ipAddress.DomainCount}
                </b>
                {' '}linking {ipAddress.DomainCount == 1 ? 'domain': 'domains'}
            </td>
        </tr>
    )
}
